(function () {
  function markReveal() {
    var groups = [
      { selector: '[id$="__839d82ac-81f6-4e90-9ea4-309f21d90b44"] .image-with-text', stagger: true },
      { selector: '[id$="__quality"] .rich-text__wrapper' },
      { selector: '[id$="__cta"] .rich-text__wrapper' }
    ];
    groups.forEach(function (group) {
      var els = document.querySelectorAll(group.selector);
      els.forEach(function (el, i) {
        el.classList.add('a2k-reveal');
        if (group.stagger) el.style.transitionDelay = (i * 0.12) + 's';
      });
    });
  }

  function initReveal() {
    var revealEls = document.querySelectorAll('.a2k-reveal');
    if (!revealEls.length) return;

    if (!('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    revealEls.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initSideNav() {
    var sectionDefs = [
      { selector: '[id$="__hero"]', label: 'Who We Are' },
      { selector: '[id$="__839d82ac-81f6-4e90-9ea4-309f21d90b44"]', label: 'Our Focus' },
      { selector: '[id$="__quality"]', label: 'What Drives Us' },
      { selector: '[id$="__cta"]', label: 'Get In Touch' }
    ];

    var sections = sectionDefs
      .map(function (def) {
        var el = document.querySelector(def.selector);
        return el ? { el: el, label: def.label } : null;
      })
      .filter(Boolean);

    if (sections.length < 2 || !('IntersectionObserver' in window)) return;

    var nav = document.createElement('nav');
    nav.className = 'a2k-about-nav';
    nav.setAttribute('aria-label', 'Page sections');

    var items = sections.map(function (section) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'a2k-about-nav__item';

      var dot = document.createElement('span');
      dot.className = 'a2k-about-nav__dot';
      dot.setAttribute('aria-hidden', 'true');

      var label = document.createElement('span');
      label.className = 'a2k-about-nav__label';
      label.textContent = section.label;

      item.appendChild(dot);
      item.appendChild(label);
      item.addEventListener('click', function () {
        section.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      nav.appendChild(item);
      return item;
    });

    document.body.appendChild(nav);

    function setActive(index) {
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });
    }

    var spyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var index = sections.findIndex(function (s) {
            return s.el === entry.target;
          });
          if (index !== -1) setActive(index);
        });
      },
      { rootMargin: '-40% 0px -40% 0px', threshold: 0 }
    );
    sections.forEach(function (s) {
      spyObserver.observe(s.el);
    });

    nav.classList.add('is-visible');
    setActive(0);
  }

  markReveal();
  initReveal();
  initSideNav();
})();
